//client side service for hitting ibms api
import http from "../boot/http.js";
import config from "../boot/config";
import moment from "moment";

const route = config.ibmsBaseUrl;
const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default class {
	static TrendableDataGetData(pointId, from, to, tariffId, tariffVersionId, period, useLive, excludeSubviews, func, calculationId) {
		if (!pointId) {
			console.error("Parameter missing.");
			return;
		}

		if(from.format === undefined) {
			from = moment(from);
		}

		if(to !== "now" && to.format === undefined) {
			to = moment(to);
		}

		let fromFormatted = from.format(dateFormat);
		let toFormatted = (to === "now" ? to : to.format(dateFormat));

		const ids = pointId.split(",");
		let urls = [];
		let url = `${route}TrendableData/GetData/${ids[0]}`;

		for (let index = 1; index < ids.length; index++) {
			const id = ids[index];
			if (index % 20 === 0) {
				urls.push(url);
				let url = `${route}TrendableData/GetData/${ids[index]}`;
			} else {
				url += "," + id;
			}
		}
		urls.push(url);

		//split network calls into max 20 ids per call, wait for all to finish then merge the result back together
		return new Promise((resolve, reject) => {
			let rtns = {};
			Promise.all(
				urls.map(url => {
					let params = {
						from: fromFormatted,
						to: toFormatted,
						tariffId: tariffId,
						tariffVersionId: tariffVersionId,
						period: period,
						useLive: useLive,
						function: func,
						excludeSubviews: excludeSubviews === undefined ? true : excludeSubviews,
						calculationId
					};
					return http({ url, method: "GET", params })
						.then(data => {
							if (Array.isArray(data)) {
								rtns = data;
							} else {
								rtns = { ...rtns, ...data };
							}
						})
						.catch(error => {
							resolve(error);
							resolve = () => null; //noop
							reject = () => null; //noop
							rtns = error;
						});
				})
			).then(x => {
				resolve(rtns);
			});
		});
	}

	static TrendableDataGetDataEmissions(pointId, from, to, period, useLive, excludeSubviews, state) {
		if (!pointId) {
			console.error("Parameter missing.");
			return;
		}
		const ids = pointId.split(",");
		let urls = [];
		let url = `${route}TrendableData/GetData/${ids[0]}`;

		for (let index = 1; index < ids.length; index++) {
			const id = ids[index];
			if (index % 20 === 0) {
				urls.push(url);
				let url = `${route}TrendableData/GetData/${ids[index]}`;
			} else {
				url += "," + id;
			}
		}
		urls.push(url);

		//split network calls into max 20 ids per call, wait for all to finish then merge the result back together
		return new Promise((resolve, reject) => {
			let rtns = {};
			Promise.all(
				urls.map(url => {
					return http({
						url,
						method: "GET",
						from: from.format(dateFormat),
						to: to == "now" ? to : to.format(dateFormat),
						period,
						useLive,
						excludeSubviews: excludeSubviews === undefined ? true : excludeSubviews,
						useEmissions: true,
						state
					})
						.then(data => {
							if (Array.isArray(data)) {
								rtns = data;
							} else {
								rtns = { ...rtns, ...data };
							}
						})
						.catch(error => {
							resolve(error);
							resolve = () => null; //noop
							reject = () => null; //noop
							rtns = error;
						});
				})
			).then(x => {
				resolve(rtns);
			});
		});
	}

	static TrendableDataGetAsAt(pointId, timestamp) {
		if (!pointId) {
			console.error("Parameter missing.");
			return;
		}
		let url = `${route}TrendableData/GetData/${pointId}`;
		let params = {
			asAt: timestamp.format(dateFormat)
		};
		return http({ url, method: "GET", params })
			.then(data => data)
			.catch(error => error);
	}

	static TrendableObjectGetObject(pointId) {
		if (!pointId) {
			console.error("Parameter missing.");
			return;
		}
		let url = `${route}TrendableObject/GetObject/${pointId}`;

		return http({ url, method: "GET" })
			.then(data => data)
			.catch(error => error);
	}

	static TrendableObjectGetByName(name) {
		if (!name) {
			return;
		}
		let url = `${route}TrendableObject/GetByName`;

		return http({ url, method: "GET", name })
			.then(data => data)
			.catch(error => error);
	}

	static TrendableObjectGetChildrenForRoot(id) {
		if (!id) {
			console.error("Parameter missing.");
			return;
		}
		let url = `${route}TrendableObject/GetRoot/${id}`;

		return http({ url, method: "GET" })
			.then(data => data)
			.catch(error => error);
	}

	static TrendableObjectGetChildrenFor(id, fullTree = false) {
		if (!id) {
			console.error("Parameter missing.");
			return;
		}
		let url = `${route}TrendableObject/GetChildren/${id}`;

		return http({
			url,
			method: "GET",
			fullTree,
			cacheOptions: { useCache: false, refreshIntervalMins: 15, deleteAfterInactiveDays: 90 }
		})
			.then(data => {
				return data.filter(x => !x.name.startsWith("000AAA"));
			})
			.catch(error => error);
	}

	static LiveDataGet(ids) {
		let joined = ids;
		if (typeof ids === Array) {
			joined = ids.join(",");
		}

		let url = `${route}LiveData/Get/?id=${joined}&excludeSubViews=true`;

		return http({ url, method: "GET", isCustom: true })
			.then(data => data)
			.catch(error => error);
	}

	static LiveDataGetRollingHour(ids, tariffId, tariffVersionId, excludeSubviews, useEmissions, state) {
		let joined = ids;
		if (typeof ids === Array) {
			joined = ids.join(",");
		}
		let url = `${route}LiveData/GetRollingHour/?id=${joined}`;

		return http({ url, method: "GET", isCustom: true, tariffId, tariffVersionId, excludeSubviews, useEmissions, state })
			.then(data => data)
			.catch(error => error);
	}

	static LiveDataGetRange(ids, from, func, tariffId, tariffVersionId) {
		let joined = ids;
		if (typeof ids === Array) {
			joined = ids.join(",");
		}
		let params = {
			from: moment(from).format(dateFormat),
			to: "now",
			function: func,
			tariffId: tariffId,
			tariffVersionId: tariffVersionId,
			period: "Daily",
			useLive: true,
			excludeSubviews: true
		};
		let url = `${route}TrendableData/GetData/?id=${joined}`;

		return http({ url, method: "GET", isCustom: true, params })
			.then(data => data)
			.catch(error => error);
	}

	static NABERSGetSites() {
		let url = `${route}NABERS/GetSites`;

		return http({ url, method: "GET" })
			.then(data => data)
			.catch(error => error);
	}

	static TariffGetByName(name) {
		let url = `${route}Tariff/GetByName`;

		return http({ url, method: "GET", name })
			.then(data => data)
			.catch(error => error);
	}

	static TariffGetDetails(tariffId) {
		let url = `${route}Tariff/GetDetails/${tariffId}`;

		return http({ url, method: "GET" })
			.then(data => data)
			.catch(error => error);
	}

	static TariffGetVersions(tariffId) {
		let url = `${route}Tariff/GetVersions/${tariffId}`;

		return http({ url, method: "GET" })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleInstance(instId) {
		if (!instId) {
			console.error("Parameter missing.");
			return;
		}
		let url = `${config.baseUrl}Rule/GetRuleInstanceForGraph/${instId}`;

		return http({ url, method: "GET" })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleInstanceData(instId, status, from, to) {
		if (!instId) {
			console.error("Parameter missing.");
			return;
		}
		let url = `${config.baseUrl}Rule/GetRuleInstanceDataForGraph/${instId}`;
		let params = {
			from: from.format(dateFormat),
			to: to === "now" ? moment().format(dateFormat) : to.format(dateFormat),
			status
		};
		return http({ url, method: "GET", params })
			.then(data => data)
			.catch(error => error);
	}
}



// WEBPACK FOOTER //
// ./src/services/points.js